import { __awaiter, __generator } from "tslib";
import { getSiteRolloutStatus } from '@wix/ambassador-bookings-v1-site-rollout-status/http';
export var isBookingsOnEcom = function (request, _a) {
    var httpClient = _a.httpClient;
    return __awaiter(void 0, void 0, void 0, function () {
        var siteRolloutStatusResponse, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, httpClient.request(getSiteRolloutStatus(request))];
                case 1:
                    siteRolloutStatusResponse = (_c.sent()).data;
                    return [2 /*return*/, siteRolloutStatusResponse.siteRolloutStatus.isBookingPlatformReady];
                case 2:
                    _b = _c.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, false];
            }
        });
    });
};
//# sourceMappingURL=isBookingsOnEcom.js.map